export default {
  '***': {
    '***': {
      headerHeight: 80,
      rowTitleHeight: 35,
      padding: 1,
      aspectRatio: 0.7727,
      externalHeaderHeight: 0,
      minContainerHeight: 1000,
      horizontalMargin: 10,
      verticalMargin: 10,
      rows: [
        {
          height: 0.33,
          title: 'IN-MARKET PERFORMANCE',
          data: [
            {
              content: [
                {
                  component: 'MetricDonut',
                  data: {
                    metric: 100,
                    metricScale: 200
                  }
                }
              ],
              width: 0.3,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricVerticalArray',
                  data: {
                    label: 'Persuasion',
                    metrics: [
                      {
                        metric: 103,
                        maxValue: 0.8,
                        format: '%,1'
                      },
                      {
                        metric: 104,
                        maxValue: 0.8,
                        format: '%,1'
                      }
                    ]
                  }
                }
              ],
              width: 0.35,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricTable',
                  data: {
                    label: 'Action',
                    metrics: [
                      { metric: 105, isHeaderMetric: true, isCapitalized: true },
                      { metric: 106, isHeaderMetric: true },
                      { metric: 108, isHeaderMetric: true },
                      { metric: 180, isHeaderMetric: true },
                      { metric: 181, isHeaderMetric: true },
                      { metric: 109, isHeaderMetric: true },
                      { metric: 112, isHeaderMetric: true },
                      { metric: 113, isHeaderMetric: true },
                      { metric: 114, isHeaderMetric: true },
                      { metric: 182, isHeaderMetric: true }
                    ]
                  }
                }
              ],
              width: 0.35,
              key: null
            }
          ]
        },
        {
          height: 0.67,
          title: 'CREATIVE PERFORMANCE',
          data: [
            {
              content: [
                {
                  component: 'MetricTable',
                  data: {
                    label: 'Branding',
                    metrics: [
                      { metric: 192, isHeaderMetric: true },
                      { metric: 115, isHeaderMetric: true },
                      { metric: 116, isHeaderMetric: true },
                      { metric: 118, isHeaderMetric: true }
                    ]
                  }
                }
              ],
              legend: {
                xOffset: 10,
                yOffset: -20
              },
              width: 0.3,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricChart',
                  data: {
                    title: 'Creative Efficiency',
                    mainMetric: {

                    },
                    subMetrics: [
                      { metric: 126, label: 'Brand Connection' },
                      { metric: 144, label: 'Cognitive Connection' },
                      { metric: 159, label: 'Engagement' },
                      { metric: 132, label: 'Category Connection' },
                      { metric: 139, label: 'Relevance' },
                      { metric: 152, label: 'Product Connection' }
                    ]
                  }
                }
              ],
              width: 0.35,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricOpenend',
                  data: {
                    label: 'In Their Own Words',
                    topBox: {
                      likes: {
                        metric: 124,
                        noStatColor: '#BFBFBF'
                      },
                      dislikes: {
                        metric: 125,
                        noStatColor: '#AFABAB'
                      }
                    },
                    messageField: 'message',
                    wordcloudConfig: {
                      sentiments: [
                        { color: '#FF872F', description: 'Very Negative' },
                        { color: '#FFC397', description: 'Negative' },
                        { color: '#DAD9D6', description: 'Neutral' },
                        { color: '#C4E1AF', description: 'Positive' },
                        { color: '#89C35F', description: 'Very Positive' }
                      ],
                      scoreRange: [0, 7],
                      font: 'Arial, Helvetica, sans-serif',
                      showCounts: true,
                      padding: 5,
                      rotation: 0,
                      wordCountCutoff: 2,
                      wordLengthCutoff: 3,
                      numDisplayed: 100
                    }
                  }
                }
              ],
              width: 0.35,
              key: null
            }
          ]
        }
      ],
      legend: {
        metadataFields: [
          {
            value: 'last_month_tested',
            label: 'Last Tested'
          }
        ],
        includeSelections: true,
        includeStatTesting: true,
        includeFilters: {
          label: 'Target',
          default: 'Total'
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/configuration/TmobileBussiness/config/components/quickview/index.js